export var ThemeEnum;
(function (ThemeEnum) {
    ThemeEnum["Primary"] = "primary";
    ThemeEnum["Secondary"] = "secondary";
    ThemeEnum["Tertiary"] = "tertiary";
    ThemeEnum["PrimaryVf"] = "primary-vf";
})(ThemeEnum || (ThemeEnum = {}));
export var GebruikerType;
(function (GebruikerType) {
    GebruikerType["Administratiekantoor"] = "Administratiekantoor";
    GebruikerType["BevoegdGezag"] = "BevoegdGezag";
    GebruikerType["Gebruikersbeheerder"] = "Gebruikersbeheerder";
    GebruikerType["Intern"] = "Intern";
    GebruikerType["Poolbeheerder"] = "Poolbeheerder";
})(GebruikerType || (GebruikerType = {}));
